// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2Ss90","form":"styles_form__34eo7"};